import React, { useState } from 'react';
import { clsb } from 'js/utils/classNames.util';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import { PendingLimitsItem } from './components/PendingLimitsItem';

import style from './PendingLimits.scss';

export const PendingLimits = ({ limits, limitType, classNames = {} }) => {
    const [confirmError, setConfirmError] = useState('');

    return (
        <div className={`${clsb([style, classNames], ['pendingContainer'])} cms-rg-pending-limits`}>
            {confirmError && <ErrorMessage error={confirmError} className={style.error} animate={true} />}
            {
                limits.map((limit, key) => <PendingLimitsItem
                    key={key}
                    limit={limit}
                    limitType={limitType}
                    classNames={classNames}
                    setConfirmError={setConfirmError}
                />)
            }
        </div>
    );
};
